import React from 'react';
import {Provider} from "react-redux";
import routes from './routes';
import storeFactory from './store';
import {addError} from './store/actions';
import defaultState from './defaultState';
import C from './constants';

const App = () => {
  const initialState = (localStorage["test-depresia-redux-store"]) ? JSON.parse(localStorage["test-depresia-redux-store"]) : defaultState;
  const saveState = () => localStorage["test-depresia-redux-store"] = JSON.stringify(store.getState());
  const handleError = error => {
    store.dispatch(
        addError(error.message)
    )
  };
  const store = storeFactory(initialState);
  store.subscribe(saveState);
  window.React = React;
  window.store = store;
  window.addEventListener("error", handleError);

  let timeStarted = initialState.testData.timeStarted;
  let dateNow = Date.now();

  if (timeStarted + (6 * 60 * 60 * 1000) < dateNow) {
    store.dispatch({type: C.RESET_HARD});
  }

  return (
      <Provider store={store}>
        {routes}
      </Provider>
  );
};

export default App;
